/** @type {import('../schema').ProcessDefinition} */
const mora = {
  id: "mora-legal",
  name: "Mora por atraso (Ley 19.604)",
  category: "finanzas",
  outcome:
    "Sobre la deuda vencida se cobra el reajuste (Decreto-Ley 14.500, vía UI) más el interés del 12% anual no capitalizable (Ley 19.604), atribuido a la unidad y al deudor — incluido quien pagó tarde.",
  trigger:
    "Se dispara automáticamente durante el Cierre de mes cuando hay deuda de meses anteriores impaga o pagada fuera de término.",
  actors: ["Administrador", "Sistema", "Residente"],
  status: "COMPLETO",
  description:
    "Modelo incremental sin doble cobro: deriva de los pagos de interés existentes hasta qué fecha ya se cobró, indexa el capital por la variación de la Unidad Indexada, aplica el 12% anual simple sobre el capital reajustado, y arma el 'Recargo por mora' + 'Reajuste (UI)' bajo la unidad del deudor. Excluye saldos iniciales/migración. La mora también alcanza a quien pagó tarde entre cierres (devenga hasta la fecha de pago real).",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "res", actor: "Residente" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "admin",
      type: "start",
      label: "Inicia el cierre del mes",
      description: "Al generar el cierre, el sistema evalúa si corresponde cobrar mora sobre deuda vencida.",
      evidence: "src/screens/admin/CierreMes.jsx:553",
    },
    {
      id: "s2",
      laneId: "sys",
      type: "decision",
      label: "¿El edificio tiene mora configurada?",
      description: "Requiere tasa de interés (tope 12% anual) o monto fijo en Editar Edificio → Finanzas.",
      evidence: "src/screens/admin/EditarEdificio.jsx",
    },
    {
      id: "sNo",
      laneId: "sys",
      type: "end",
      label: "Sin mora",
      description: "Sin configuración de interés, el cierre continúa sin cobrar mora.",
    },
    {
      id: "s3",
      laneId: "sys",
      type: "task",
      label: "Escanea la deuda vencida",
      description:
        "Toma pagos de meses anteriores: los impagos y también los que se pagaron TARDE (fecha de pago posterior al vencimiento). Excluye saldos iniciales / migración.",
      evidence: "src/screens/admin/CierreMes.jsx:1483",
    },
    {
      id: "s4",
      laneId: "sys",
      type: "task",
      label: "Calcula el período aún no cobrado",
      description:
        "Deriva de los pagos de interés existentes hasta qué fecha ya se cobró (evita doble cobro). Respeta la fecha de activación (moraStartDate): no cobra retroactivo. Al borrar un cierre, la mora se recalcula sola.",
      evidence: "src/utils/interestCalculation.js",
    },
    {
      id: "s5",
      laneId: "sys",
      type: "decision",
      label: "¿Indexación por UI activa?",
      description: "Toggle 'Aplicar indexación por UI (Decreto-Ley 14.500)' en Finanzas.",
      evidence: "src/utils/exchangeRates.js",
    },
    {
      id: "s6",
      laneId: "sys",
      type: "task",
      label: "Reajuste por variación de la UI",
      description:
        "capitalReajustado = deuda × (UI_fin / UI_inicio). El reajuste (14.500) se lista aparte como 'Reajuste (UI)'.",
      evidence: "src/utils/interestCalculation.js",
    },
    {
      id: "s7",
      laneId: "sys",
      type: "task",
      label: "Interés 12% anual no capitalizable",
      description:
        "Interés simple = capitalReajustado × 12%/365 × días de atraso. Tope legal 12% (Ley 19.604). Para quien pagó tarde, devenga hasta la fecha de pago real.",
      evidence: "src/utils/interestCalculation.js",
    },
    {
      id: "s8",
      laneId: "sys",
      type: "document",
      label: "Arma la mora por unidad",
      description:
        "Mora total = reajuste + recargo. Se atribuye SIEMPRE a la unidad del pago vencido y a su deudor (incluido el ocupante saliente).",
      evidence: "src/screens/admin/CierreMes.jsx",
    },
    {
      id: "s9",
      laneId: "admin",
      type: "task",
      label: "Revisa la vista previa de mora",
      description:
        "El admin ve por unidad: período, concepto, deuda, reajuste, recargo y total; puede desmarcar lo que no quiera incluir.",
      evidence: "src/screens/admin/CierreMes.jsx",
    },
    {
      id: "s10",
      laneId: "sys",
      type: "task",
      label: "Incluye la mora en la deuda",
      description:
        "Suma al payment del residente el desglose 'Reajuste (UI)' + 'Recargo por mora', bajo su unidad.",
      evidence: "src/utils/fundHelpers.js",
    },
    {
      id: "s11",
      laneId: "res",
      type: "end",
      label: "El residente ve el recargo por mora",
      description:
        "En Cobranza y en 'Mi Cuenta' aparece el reajuste y el recargo por mora, itemizados (exigencia legal de itemización).",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3", label: "sí" },
    { from: "s2", to: "sNo", label: "no" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6", label: "sí" },
    { from: "s5", to: "s7", label: "no (solo 12%)" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
    { from: "s8", to: "s9" },
    { from: "s9", to: "s10" },
    { from: "s10", to: "s11" },
  ],
};

export default mora;
